export default __webpack_public_path__ + "static/media/logo-blanco.81da7a03.svg";